export default __webpack_public_path__ + "images/process_6.svg?7adcc70e24bb77d1c60332c90622a828";